const rankingItems = [
  { rank: 1, title: '奔跑吧 第十二季', heat: '本周热度 12.8万', type: '户外竞技', trend: 'hot' },
  { rank: 2, title: '乘风2024', heat: '本周热度 15.2万', type: '音乐竞演', trend: 'rising' },
  { rank: 3, title: '王牌对王牌 第八季', heat: '本周热度 11.6万', type: '喜剧综艺', trend: 'hot' },
  { rank: 4, title: '这就是街舞 第七季', heat: '本周热度 10.3万', type: '舞蹈竞技', trend: 'hot' },
  { rank: 5, title: '密室大逃脱 第五季', heat: '本周热度 9.8万', type: '悬疑推理', trend: 'rising' },
  { rank: 6, title: '心动的信号 第七季', heat: '本周热度 8.5万', type: '恋爱观察', trend: 'stable' },
  { rank: 7, title: '天赐的声音 第五季', heat: '本周热度 7.9万', type: '音乐综艺', trend: 'rising' },
];

const rankColors: Record<number, string> = {
  1: 'bg-accent-500 text-white',
  2: 'bg-accent-400 text-white',
  3: 'bg-accent-300 text-white',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4 whitespace-nowrap">
              热门榜单
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              综艺热度排行榜
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-2xl mx-auto">
              基于全网热度数据实时更新，看看你追的综艺排第几
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="bg-background-50 border border-background-200 rounded-2xl overflow-hidden">
              {rankingItems.map((item, idx) => (
                <div
                  key={item.title}
                  className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-primary-50/50 transition-all ${
                    idx < rankingItems.length - 1 ? 'border-b border-background-200' : ''
                  }`}
                >
                  <div
                    className={`w-9 h-9 flex items-center justify-center rounded-xl text-sm font-black flex-shrink-0 ${
                      rankColors[item.rank] || 'bg-secondary-100 text-secondary-600'
                    }`}
                    style={item.rank > 3 ? { fontFamily: 'var(--font-heading)' } : undefined}
                  >
                    {item.rank <= 3 ? item.rank : item.rank}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm md:text-base font-bold text-foreground-900 truncate">
                      {item.title}
                    </h3>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-xs text-foreground-500">{item.type}</span>
                      <span className="text-xs text-foreground-400">·</span>
                      <span className="text-xs text-foreground-500">{item.heat}</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0">
                    {item.trend === 'hot' && (
                      <span className="flex items-center gap-1 text-xs text-primary-500 font-medium whitespace-nowrap">
                        <i className="ri-fire-line"></i> 热播
                      </span>
                    )}
                    {item.trend === 'rising' && (
                      <span className="flex items-center gap-1 text-xs text-accent-600 font-medium whitespace-nowrap">
                        <i className="ri-arrow-up-line"></i> 上升
                      </span>
                    )}
                    {item.trend === 'stable' && (
                      <span className="flex items-center gap-1 text-xs text-foreground-500 font-medium whitespace-nowrap">
                        <i className="ri-subtract-line"></i> 稳定
                      </span>
                    )}
                    <i className="ri-arrow-right-s-line text-foreground-400"></i>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}